import React from "react";

type FileInputProps = {
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | File | null;
  label: string;
  name: string;
  accept?: string;
};

const FileInput = ({
  handleFormChange,
  value,
  label,
  name,
  accept = "image/*",
}: FileInputProps) => {
  return (
    <div className="max-w-[350px]" id={"container" + name}>
      <div className="flex flex-col gap-2">
        <label htmlFor={name}>{label}</label>
        <div className="border-2">
          <input
            type="file"
            id={name}
            name={name}
            onChange={handleFormChange}
            accept={accept}
          />
        </div>

        {value && (
          <img
            src={typeof value === "string" ? value : URL.createObjectURL(value)}
            alt={label}
            width={200}
            height={200}
          />
        )}
      </div>
    </div>
  );
};

export default FileInput;
